<h1 class="container-heading">Box Items List</h1>
<mat-card>
    <common-table2 *ngIf="boxItemsTable" [settings]="boxItemsTable"></common-table2>
</mat-card>
